import { useFeatureFlags } from './useFeatureFlags';

export function useAssetMergeEnabled(): boolean {
  const { isFeatureFlagEnabled: isAssetMergeEnabled } = useFeatureFlags(
    'ASSET_MERGE_ENABLED',
  );
  const { isFeatureFlagEnabled: isScheduledAssetDedupEnabled } =
    useFeatureFlags('SCHEDULED_ASSET_DEDUP');

  return isAssetMergeEnabled || isScheduledAssetDedupEnabled;
}
